<template>
  <page-frame :header="path">
    <el-skeleton :loading="loading" animated style="margin: 20px 40px">
      <template slot="template">
        <div class="title-md">
          <el-skeleton-item variant="text" style="width: 10%" />
        </div>
        <artical-card
          v-for="(_, i) in Array(5)"
          :key="i - 5"
          :info="{}"
          :loading="true"
          style="margin-bottom: 20px"
        />
      </template>
      <template>
        <div
          v-for="publicationsList in publicationsByYears"
          :key="publicationsList[0].time.getYear()"
          style="margin-bottom: 40px"
        >
          <div class="title-md" :id="publicationsList[0].time.getFullYear()">
            {{ publicationsList[0].time.getFullYear() }}
          </div>
          <artical-card
            v-for="info in publicationsList"
            :info="info"
            :key="info.id"
            :loading="false"
            style="margin-bottom: 20px"
          />
        </div>
      </template>
    </el-skeleton>
    <el-button
      v-if="$store.state.token"
      type="primary"
      icon="el-icon-edit"
      circle
      @click="newArtical"
      style="
        position: fixed;
        right: 100px;
        bottom: 100px;
        width: 60px;
        height: 60px;
      "
    />
  </page-frame>
</template>
<script>
import ArticalCard from "../components/ArticalCard.vue";
import PageFrame from "../components/PageFrame.vue";

export default {
  name: "publicationsPage",
  components: { ArticalCard, PageFrame },
  created() {
    this.$axios.get("/publications/").then((res) => {
      this.loading = false;
      const publicationsList = res.data.data.records
        .map((x) => {
          return {
            ...x,
            time: new Date(x.created),
            type: "publication",
          };
        })
        .sort((a, b) => (a.time < b.time ? 1 : -1));

      if (publicationsList.length > 0)
        this.publicationsByYears.push([publicationsList[0]]);
      for (let i = 1; i < publicationsList.length; i++) {
        if (
          publicationsList[i - 1].time.getYear() ==
          publicationsList[i].time.getYear()
        ) {
          this.publicationsByYears[this.publicationsByYears.length - 1].push(
            publicationsList[i]
          );
        } else {
          this.publicationsByYears.push([publicationsList[i]]);
        }
      }
    });
  },
  data() {
    return {
      path: [
        { path: "", breadcrumbName: this.$t("navigation.home") },
        {
          path: "publications",
          breadcrumbName: this.$t("navigation.publications"),
        },
      ],
      loading: true,
      publicationsByYears: [],
      newArtical: () => {
        this.$router.push("publicationdetail");
      },
      
    };
  },
};
</script>
